<template>
  <div :style="{ padding: '0 50px', marginTop: '64px', zIndex: 1 }">
    <div :style="{ background: '#fff', padding: '24px', minHeight: '880px' }">
      <a-row :gutter="32">
        <a-col :span="14" :xs="24" :sm="24" :md="24" :lg="14">
          <a-row :gutter="16">
            <a-col :span="12" :xs="24" :sm="24" :md="24" :lg="12">
              <BirthRateChart />
            </a-col>
            <a-col :span="12" :xs="24" :sm="24" :md="24" :lg="12">
              <BirthBearChart />
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="12" :xs="24" :sm="24" :md="24" :lg="12">
              <PopulationAgeAboveChart />
            </a-col>
            <a-col :span="12" :xs="24" :sm="24" :md="24" :lg="12">
              <LifeExpectancy />
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="10" :xs="24" :sm="24" :md="24" :lg="10">
          
          <a-button id="japan-btn" class="japan-btn-color" @click="chooseJapan">Japan</a-button>
          <a-button id="italy-btn" class="italy-btn-color" @click="chooseItaly">Italy</a-button>
          <a-button id="finland-btn" class="finland-btn-color" @click="chooseFinland">Finland</a-button>
          <a-button id="france-btn" class="france-btn-color" @click="chooseFrance">France</a-button>
          <a-button id="spain-btn" class="spain-btn-color" @click="chooseSpain">Spain</a-button>
          <a-button id="uk-btn" class="uk-btn-color" @click="chooseUK">UK</a-button>
          <a-button id="canada-btn" class="canada-btn-color" @click="chooseCanada">Canada</a-button>
          <a-button id="us-btn" class="us-btn-color" @click="chooseUS">United States</a-button>
          <a-button id="australia-btn" class="australia-btn-color" @click="chooseAustralia">Australia</a-button>
          <a-button id="iceland-btn" class="iceland-btn-color" @click="chooseIceland">Iceland</a-button>
          <a-button id="china-btn" class="china-btn-color" @click="chooseChina">China</a-button>
          <a-button id="chile-btn" class="chile-btn-color" @click="chooseChile">Chile</a-button>
          <a-button id="turkey-btn" class="turkey-btn-color" @click="chooseTurkey">Turkey</a-button>
          <a-button id="mexico-btn" class="mexico-btn-color" @click="chooseMexico">Mexico</a-button>
          <MapBoxVanilla mapWidth="100%" 
          mapHeight="600px" 
          :chooseChina="this.chooseChina"
          :chooseJapan="this.chooseJapan"
          :chooseItaly="this.chooseItaly"
          :chooseFinland="this.chooseFinland"
          :chooseFrance="this.chooseFrance"
          :chooseSpain="this.chooseSpain"
          :chooseUK="this.chooseUK"
          :chooseCanada="this.chooseCanada"
          :chooseUS="this.chooseUS"
          :chooseAustralia="this.chooseAustralia"
          :chooseIceland="this.chooseIceland"
          :chooseChile="this.chooseChile"
          :chooseTurkey="this.chooseTurkey"
          :chooseMexico ="this.chooseMexico"
          ></MapBoxVanilla>
          <br>
          <h3>As these graphs showing, all aging population countries have some shared properties. They all tend to have
            a decreasing birth rate, increasing childbearing age, increasing the number of population age 65+, and increasing 
            life expectancy in the past 60 years. And the aging population problem does not have a tight relation with 
            countries' geographic location.
          </h3>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3";
import BirthRateChart from "../components/reason/birthRateChart.vue";
import BirthBearChart from "../components/reason/birthBearChart.vue";
import PopulationAgeAboveChart from "../components/reason/populationAge65Above.vue";
import LifeExpectancy from "../components/reason/lifeExpectancy.vue";
import MapBoxVanilla from "../components/reason/mapBoxVanilla";
export default {
  name: "Reason",
  components: {
    BirthRateChart,
    BirthBearChart,
    PopulationAgeAboveChart,
    LifeExpectancy,
    MapBoxVanilla,
  },
  methods: {
    chooseChina() {
      this.chooseCountry("China");
      this.switchBtnColor("china-btn");
    },

    chooseJapan() {
      this.chooseCountry("Japan");
      this.switchBtnColor("japan-btn");
    },

    chooseItaly(){
      this.chooseCountry("Italy");
      this.switchBtnColor("italy-btn");
    },
    chooseFinland() {
      this.chooseCountry("Finland");
      this.switchBtnColor("finland-btn");
    },
    chooseFrance() {
      this.chooseCountry("France");
      this.switchBtnColor("france-btn");
    },
    chooseSpain() {
      this.chooseCountry("Spain");
      this.switchBtnColor("spain-btn");
    },
    chooseUK() {
      this.chooseCountry("United Kingdom");
      this.switchBtnColor("uk-btn");
    },
    chooseCanada() {
      this.chooseCountry("Canada");
      this.switchBtnColor("canada-btn");
    },
    chooseUS() {
      this.chooseCountry("United States");
      this.switchBtnColor("us-btn");
    },
    chooseAustralia() {
      this.chooseCountry("Australia");
      this.switchBtnColor("australia-btn");
    },
    chooseIceland() {
      this.chooseCountry("Iceland");
      this.switchBtnColor("iceland-btn");
    },
    chooseChile() {
      this.chooseCountry("Chile");
      this.switchBtnColor("chile-btn");
    },
    chooseTurkey() {
      this.chooseCountry("Turkey");
      this.switchBtnColor("turkey-btn");
    },
    chooseMexico() {
      this.chooseCountry("Mexico");
      this.switchBtnColor("mexico-btn");
    },

    switchBtnColor(countryname) {
      var btn = d3.select(`#${countryname}`).classed(`${countryname}-color`);
      d3.select(`#${countryname}`).classed(`${countryname}-color`, !btn);
    },
    chooseCountry(countryName) {
      var hasFaded = d3
        .selectAll(".birth-ratio-chart-line")
        .filter(function () {
          return d3.select(this).attr("name") === countryName;
        });
      // console.log("hasFaded is ", hasFaded);
      if (hasFaded.classed("fade-line")) {
        return hasFaded.classed("fade-line", false);
      } else {
        return hasFaded.classed("fade-line", true);
      }
    },
    chooseCountryV2(countryName) {
      d3.selectAll(".birth-ratio-chart-line")
        .filter(function () {
          return d3.select(this).attr("name") === countryName;
        })
        .classed("highlight-line", true)
        .classed("fade-line", (d) => [console.log("d is ", d)]);
      d3.selectAll(".birth-ratio-chart-line")
        .filter(function () {
          // console.log('inner this is ',this)
          return d3.select(this).attr("name") !== countryName;
        })
        .classed("fade-line", true)
        .classed("highlight-line", false);
    },
    
  },
};
</script>

<style>
.birth-ratio-chart-line {
  fill: none;
  stroke: steelblue;
  stroke-width: 2px;
}

.fade-line {
  opacity: 0.05;
}

.highlight-line {
  opacity: 1;
}
.normal-line {
  opacity: 0.8;
}

.china-btn-color {
  background: #fb6a4a !important;
  color:white !important;
}

.japan-btn-color {
  background: #67000d !important;
  color:white !important;
}
.italy-btn-color {
  background: #67000d !important;
  color:white !important;
}
.finland-btn-color {
  background:#67000d !important;
  color:white !important;
}
.france-btn-color {
  background: #67000d !important;
  color:white !important;
}
.spain-btn-color {
  background:#67000d !important;
  color:white !important;
}
.uk-btn-color {
  background: #a50f15 !important;
  color:white !important;
}
.canada-btn-color {
  background:#a50f15 !important;
  color:white !important;
}
.us-btn-color {
  background: #cb181d !important;
  color:white !important;
}
.australia-btn-color {
  background: #cb181d !important;
  color:white !important;
}
.iceland-btn-color {
  background:#cb181d !important;
  color:white !important;
}
.chile-btn-color {
  background: #fb6a4a !important;
  color:white !important;
}
.turkey-btn-color {
  background: #fc9272 !important;
  color:white !important;
}
.mexico-btn-color {
  background: #fcbba1 !important;
  color:white !important;
}
.country-btn-color {
  background: #ffdde2ff !important;
}


</style>